import { useState } from "react";
import { X } from "lucide-react";
import { dot } from "../lib/fmt";

export default function WelcomeCard({ data }) {
  const key = `crk_welcome_${data.me.id}`;
  const [hidden, setHidden] = useState(localStorage.getItem(key) === "1");
  if (hidden || data.myRecentCount > 0) return null;
  const close = () => {
    localStorage.setItem(key, "1");
    setHidden(true);
  };
  const steps = [
    ["Tulis aktivitas", "Satu item per baris, singkat saja."],
    ["Isi angka KPI", `Sesuai fungsi ${data.me.role}. Kosongkan bila tidak ada.`],
    ["Kirim sebelum " + dot(data.settings.deadline), "Kode aktivitas dibuat otomatis."],
  ];
  return (
    <div data-testid="welcome-card" className="fade-up relative mt-6 rounded-3xl bg-brand-tint p-5 sm:p-6">
      <button data-testid="welcome-dismiss" onClick={close} aria-label="Tutup" className="absolute right-3 top-3 flex h-11 w-11 items-center justify-center rounded-full hover:bg-white/60"><X size={18} /></button>
      <div className="eyebrow">Selamat datang</div>
      <h2 className="mt-1 pr-10 text-xl font-extrabold">Halo {data.me.name}, begini cara lapor harian</h2>
      <ol className="mt-4 grid gap-3 sm:grid-cols-3">
        {steps.map(([t, d], i) => (
          <li key={t} className="rounded-2xl bg-white p-4">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand text-sm font-extrabold text-white">{i + 1}</div>
            <div className="mt-2 font-bold">{t}</div>
            <div className="text-sm text-[#7a6667]">{d}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}
